/**
 * @generated SignedSource<<a6f77e101ff066e2e5c44083e782128d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type batchEditGroups_QueryFragment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"inviteMemberModal_QueryFragment">;
  readonly " $fragmentType": "batchEditGroups_QueryFragment";
};
export type batchEditGroups_QueryFragment$key = {
  readonly " $data"?: batchEditGroups_QueryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"batchEditGroups_QueryFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [],
      "operation": require('./batchEditGroupsRefetchQuery.graphql')
    }
  },
  "name": "batchEditGroups_QueryFragment",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "inviteMemberModal_QueryFragment"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "4f03b8cc35fb45cfcc156af5040e96c1";

export default node;
